import { createContext, useState, useEffect } from "react";
import axios from "axios";

const CompanyContext = createContext();

const CompanyProvider = ({ children }) => {
  const [companyLogo, setCompanyLogo] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [fontFamily, setFontFamily] = useState("");
  const [headerColor, setHeaderColor] = useState("");
  const [primaryColor, setPrimaryColor] = useState("");
  const [secondaryColor, setSecondaryColor] = useState("");
  const [searchFormPosition, setSearchFormPosition] = useState("");
  const [loading, setLoading] = useState(true); // Add loading state
  const [isSearching, setIsSearching] = useState(false);

  useEffect(() => {
    const getCompanyLogo = () => {
      axios
        .get("https://hrms-api.apisod.ai/api/company-information", {})
        .then((res) => {
          const { company_information } = res.data;
          setCompanyLogo(company_information.company_logo);
          setCompanyName(company_information.CompanyName);
          setFontFamily(company_information.fontFamily);
          setHeaderColor(company_information.headerColor);
          setPrimaryColor(company_information.primaryColor);
          setSecondaryColor(company_information.secondaryColor);
          setSearchFormPosition(company_information.searchFormPosition);
          setLoading(false); // Set loading to false after data is fetched
        })
        .catch((e) => {
          console.log(e);
          setLoading(false); // Set loading to false even if there is an error
        });
    };
    getCompanyLogo();
  }, []);

  return (
    <CompanyContext.Provider
      value={{
        companyLogo,
        companyName,
        fontFamily,
        headerColor,
        primaryColor,
        secondaryColor,
        loading, // Provide loading state in context
        searchFormPosition,
        isSearching,
        setIsSearching,
      }}
    >
      {children}
    </CompanyContext.Provider>
  );
};

export { CompanyContext, CompanyProvider };
